import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function updatePrivacyPolicy(value) {
  try {
    loginfo();
    return await apiClient.post('/license/legal/policy', { value });
  } catch (error) {
    console.error('updatePrivacyPolicy failed.', error);
  }
}

export async function getTermsAndConditions() {
  try {
    const res = await tryCache('getTermsAndConditions', () =>
      apiClient.get('/license/legal/terms'),
    );
    return res;
  } catch (error) {
    console.error('getTermsAndConditions failed.', error);
  }
}

export async function getPolicyAndCookies() {
  try {
    const res = await tryCache('getPolicyAndCookies', () => apiClient.get('/license/legal/policy'));
    return res;
  } catch (error) {
    console.error('getPolicyAndCookies failed.', error);
  }
}
